export const MATCH_ANSWER = 'MatchAnswer';
export const MATCH_CLAIMCASE = 'MatchClaimcase';
export const MATCH_CLAIMCASE_EMAIL = 'MatchClaimcaseEmail';
export const MATCH_CLAIMCASE_POLICY = 'MatchClaimcasePolicy';
export const MATCH_EXTERNAL_CLAIMCASE_REF = 'MatchExternalClaimcaseRef';
export const MATCH_FNOL_ANSWER = 'MatchFnolAnswer';
export const MATCH_FNOL_INSURED_OBJECT = 'MatchFnolInsuredObject';
export const MATCH_NOTE = 'MatchNote';
export const MATCH_POLICY = 'MatchPolicy';
export const MATCH_TASK = 'MatchTask';
export const MATCH_UNLABELED_EMAIL = 'MatchUnlabeledEmail';
